import React from "react"

function Left() {
  return (
    <div className='newcomer-left'>
      <h1 className='newcomer-left-txt1'>Newcomer Tools</h1>
      <p className='newcomer-left-txt2'>
        Wow! see the latest update of the most
        <br />
        recommended tools from reliable designers
        <br />
        and developers
      </p>
      <button className='newcomer-left-btn' type='button'>
        Explore more
      </button>
    </div>
  )
}

export default Left
